// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".social-link[data-v-4a51bd86]{position:relative;display:inline-block;-webkit-transition:color 1s cubic-bezier(0.19, 1, 0.22, 1);transition:color 1s cubic-bezier(0.19, 1, 0.22, 1)}.social-link[data-v-4a51bd86]:hover{color:#e00}path[data-v-4a51bd86]{fill:currentColor !important}path[stroke-width][data-v-4a51bd86]{stroke:currentColor !important}svg[data-v-4a51bd86]{color:#141414;width:18px;height:18px}", ""]);
// Exports
module.exports = exports;
